<template>
  <div>
    <div class="logistics">
      <div class="mc-flex title">
        <el-image src style="width: 80px; height: 80px;"></el-image>
        <ul class="mc-flex mc-flex-direction-column mc-flex-justify-around">
          <li>
            <span class="gray9-text">申请时间：</span>2019-05-05 18:06:06
          </li>
          <li>
            <span class="gray9-text">申请单号：</span>00000000001
          </li>
          <li>
            <span class="gray9-text">当前状态：</span>已完成
          </li>
        </ul>
      </div>
      <div class="logist-list">
        <div class="logist-list_item" v-for="(item, index) in progress" :key="index">
          <div>{{item.text}}</div>
          <div>经办人：{{item.person}}</div>
          <p>{{item.time}}</p>
        </div>
      </div>
    </div>
    <div class="mc-flex mc-flex-justify-center mc-mt-20">
      <span class="confirm-btn mc-text-center yellow-bg mc-bold mc-cursor-default" @click="confirmClick">确定</span>
    </div>
  </div>
</template>

<script>
export default {
  props: ["progress"],
  data() {
    return {};
  },

  // components: {},

  // computed: {},

  // mounted: {},

  methods: {
    confirmClick() {
      this.$emit('confirm-click');
    }
  }
};
</script>
<style lang='less' scoped>
@import "~@/assets/css/less.less";
.logistics {
  border: 1px solid @eee;
  .title {
    padding: 20px;
    background: @f9;
    font-size: 12px;
    color: @gray6;
    border-bottom: 1px solid @eee;
    ul {
      margin-left: 30px;
    }
  }
  .logist-list {
    max-height: 350px;
    padding: 20px 40px;
    overflow-y: auto;
    .logist-list_item {
      padding: 0 0 20px 20px;
      position: relative;
      font-size: 12px;
      &:last-child {
        padding-bottom: 0;
      }
      &::after {
        content: "";
        border-right: 1px solid @ccc;
        height: 100%;
        position: absolute;
        left: 0;
        top: 3px;
      }
      &::before {
        content: "";
        width: 10px;
        height: 10px;
        border-radius: 50%;
        background: @ccc;
        position: absolute;
        left: -5px;
        top: 3px;
        z-index: 1001;
      }
      &:first-child::before {
        background: @yellow;
        box-shadow: 0 0 6px 0 @yellow;
      }
      div {
        color: @gray6;
        margin-bottom: 5px;
      }
      p {
        color: @gray9;
      }
    }
  }
}
.confirm-btn{
  display: block;
  width: 120px; 
  height: 40px;
   line-height: 40px;
}
</style>



// WEBPACK FOOTER //
// src/components/ProgressTrack.vue